module.exports = "<div class=\"lp_ai_assist_widget\"><div class=\"lp_ai_assist_suggestions\"></div></div>";